import { getUrlParams } from './helpers';

const revJetBannerConfig = {
  skyscraper: {
    tag: 'tag170885',
    key: 'aec'
  },
  desktop: {
    tag: 'tag98547',
    key: '82a'
  },
  mobile: {
    tag: 'tag98548',
    key: 'dce'
  }
};

function isSkyscraper(requestConfig) {
  return requestConfig.bannerType === 'skyscraper';
}

function getRevJetConfig(requestConfig) {
  if (isSkyscraper(requestConfig)) {
    return revJetBannerConfig.skyscraper;
  }

  return revJetBannerConfig[requestConfig.experienceContext.channel];
}

function getPubRef(data) {
  const params = getUrlParams(data.banner.bannerURL);
  return decodeURIComponent(params.pub_ref);
}

function getCreativeId(bannerURL) {
  let creativeId = '';

  if (bannerURL && bannerURL.indexOf('cdn.revjet.com') === -1) {
    const anchorElement = document.createElement('a');
    anchorElement.href = bannerURL;
    creativeId = anchorElement.pathname.split('-')[1];
  }

  return creativeId;
}

function getItcParams({ banner = {} }) {
  return {
    campaignId: banner.campaignId ? banner.campaignId : '',
    placementId: banner.placementId ? banner.placementId : '',
    slotId: banner.slotId ? banner.slotId : '',
    creativeId: getCreativeId(banner.bannerURL)
  };
}

function getTag({ channelConfig, data, requestConfig }) {
  const params = getUrlParams(window.location.href);
  let tag = '';

  if (params.mockSponsoredBannerId) {
    tag = channelConfig.tag + '-' + params.mockSponsoredBannerId;
  } else if (params.useSponsoredMock) {
    tag = channelConfig.tag + '-' + getCreativeId(data.banner.bannerURL);
  } else {
    tag = channelConfig.tag;
  }

  return tag;
}

function getFrameConfig({ data, requestConfig }) {
  const channelConfig = getRevJetConfig(requestConfig);
  const itcParams = getItcParams(data);

  return {
    thd_itc_suffix: true,
    _tag: getTag({ channelConfig, data, requestConfig }),
    _key: channelConfig.key,
    ct_url: data.banner.onClickBeacon,
    piq_slot_id: itcParams.slotId,
    piq_campaign_id: itcParams.campaignId,
    piq_placement_id: itcParams.placementId,
    _opts: {
      embd_tag_id: requestConfig.schemaId,
      autoscale: true,
      b64: getPubRef(data)
    }
  };
}

function isNormalBanner(requestConfig) {
  return requestConfig.bannerType === undefined;
}

function frameLoad({ frameConfig, data, requestConfig }) {
  const bannerDomElement = window.document.getElementById(frameConfig._opts.embd_tag_id);

  if (bannerDomElement) {

    if (isNormalBanner(requestConfig)) {
      try {
        const carousel = bannerDomElement.closest('.carousel');
        const next = carousel.querySelector('.carousel__next');
        next.click();
      } catch (error) { /* */ }
    }

    const itcParams = getItcParams(data);
    bannerDomElement.removeAttribute('data-hl-beacon'); // Remove from previous banner
    bannerDomElement.setAttribute('data-campaignId', itcParams.campaignId);
    bannerDomElement.setAttribute('data-placementId', itcParams.placementId);
    bannerDomElement.setAttribute('data-slotId', itcParams.slotId);
    bannerDomElement.setAttribute('data-creativeId', itcParams.creativeId);
    bannerDomElement.setAttribute('data-usenewimpressionlogic', true);

    let viewBeacon = data.banner.onViewBeacon;
    viewBeacon = viewBeacon ? viewBeacon.replace('https:', '') : '';
    bannerDomElement.setAttribute('onview-beacon', viewBeacon);

    if (isNormalBanner(requestConfig)) {
      window.scrollTo(window.scrollX, window.scrollY - 1);
      window.scrollTo(window.scrollX, window.scrollY + 1);

      if (window.newrelic && !window.__SponsoredBannerLoaded__) {
        window.newrelic.addPageAction('SponsoredBannerLoaded');
        window.__SponsoredBannerLoaded__ = true; // Dont fire more than once
      }
    }
  }
}

function renderFrame({ data, requestConfig }) {
  if (data) {
    const frameConfig = getFrameConfig({ data, requestConfig });
    frameConfig._opts.onload = () => frameLoad({ frameConfig, data, requestConfig });
    window.REVJET_Tag(frameConfig);
  }
}

function injectRevJetScript({ data, requestConfig }) {
  const revJetScript = document.createElement('script');
  revJetScript.onload = () => renderFrame({ data, requestConfig });
  revJetScript.async = true;
  revJetScript.src = 'https://ads.revjet.com/bg';

  const firstScript = document.getElementsByTagName('body')[0];
  firstScript.parentNode.insertBefore(revJetScript, firstScript);
}

function getMockResponse(requestConfig) {
  const { mockSponsoredBannerId } = getUrlParams(window.location.href);
  let revJetConfig = getRevJetConfig(requestConfig);
  let mockRevJetUrl = `http://ads.revjet.com/${revJetConfig.tag}-${mockSponsoredBannerId}`;
  mockRevJetUrl += `?adkey=${revJetConfig.key}&pub_ref=mock`;

  return {
    banner: {
      bannerURL: mockRevJetUrl,
      clickthruURL: 'https://www.homedepot.com/',
      /* eslint-disable-next-line */
      onViewBeacon: 'https://ad-thd-east.tagdelivery.com/impression?id=58c1e65f-1347-4a8e-974e-d1a38c2ff351&x=PQBSrMU8RPJZkBbOrjDSc18Q1ayQXTSmIeTxihTSx1y9TAuGAWAYT6d0LVZ7PodtSlSjEGL3wuSCkAhce75zYtd-2sqdeq-ApKqECLNtI40rBpnEOi566Og3XfUuZsHu0-15T3v3fSc-a7BXv68-EExUCyJFjDF7FlBAnzs1ztKoQWtu2VHTbbD6FKqRRGYRFSG7urhW1pbYdsJ-XPIdtg-L9I-O_rEEcfuW_cPu2-r7wbll5brpZCzuLnnSX5ssi-JC7-an2ySXhP26YTjmLySo4v5i7-KmTyDrmhWLWShNRqc3V43yMUQszMuiaffUgej1g-fhSG6wGdKRbQNexLFce3CmTg_wurbZat-PyhTk-i2D4AJc4qXbxoJvQO3LoIkN0kIMiQMFfuv2jn_7h3-GyF7knjxDEYzBAf6rNtc%3D',
      /* eslint-disable-next-line */
      onClickBeacon: 'https://ad-thd-east.tagdelivery.com/click?id=58c1e65f-1347-4a8e-974e-d1a38c2ff351&x=PQBSrMU8RPJZkBbOrjDSc18Q1ayQXTSmIeTxihTSx1y9TAuGAWAYT6d0LVZ7PodtSlSjEGL3wuSCkAhce75zYtd-2sqdeq-ApKqECLNtI40rBpnEOi566Og3XfUuZsHu0-15T3v3fSc-a7BXv68-EExUCyJFjDF7FlBAnzs1ztKoQWtu2VHTbbD6FKqRRGYRFSG7urhW1pbYdsJ-XPIdtg-L9I-O_rEEcfuW_cPu2-r7wbll5brpZCzuLnnSX5ssi-JC7-an2ySXhP26YTjmLySo4v5i7-KmTyDrmhWLWShNRqc3V43yMUQszMuiaffUgej1g-fhSG6wGdKRbQNexLFce3CmTg_wurbZat-PyhTk-i2D4AJc4qXbxoJvQO3LoIkN0kIMiQMFfuv2jn_7h3-GyF7knjxDEYzBAf6rNtc%3D&redirect=',
      slotId: '1123',
      campaignId: 'abc123',
      placementId: 'xyz123'
    }
  };
}

function buildRevJetBannerMock(requestConfig) {
  const data = getMockResponse(requestConfig);

  if (window.REVJET_Tag) {
    renderFrame({ data, requestConfig });
  } else {
    injectRevJetScript({ data, requestConfig });
  }
}

function buildRevJetBanner({ data, requestConfig }) {
  if (window.REVJET_Tag) {
    renderFrame({ data, requestConfig });
  } else {
    injectRevJetScript({ data, requestConfig });
  }
}

export { buildRevJetBanner, buildRevJetBannerMock, getFrameConfig, frameLoad };
